export default __webpack_public_path__ + "static/team-Mahmoud-f54c24a577a9315f5bdcf20847a01a1d.png";